import ViewIndex from "../../viewsline/view-index"
import ViewMethod from "../../viewsline/view-method"
import ViewAward from "../../viewsline/view-award"
import ViewSignup from "../../viewsline/view-signup"
import ViewSurvey from "../../viewsline/view-survey"

export default function LinestickerContent() {
    return (
        <div>
            <ViewIndex />
            <ViewMethod />
            <ViewAward />
            <ViewSignup />
            <ViewSurvey />
        </div>
    )
}